import  React, { useState } from 'react';
import { useTranslation, Translation } from 'react-i18next';
import { Container, Row, Col, Button, Collapse, Spinner, Form, Modal, ProgressBar } from 'react-bootstrap';

import classes from './TestDataSheet.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { connect } from 'react-redux';

import {
  testResultsListReturnTypes,
  TABLE_SELECT_ROW,
  isAdvanced,
  getDataSheetFromVidQuery,
  API_URLS,
  CPVO_EXPERT_ADVICE_STATUS,
  convertDate,
  checkToday,
  downloadBlob,
  compareResults,
  downloadExcelFileNames,
  downloadExcelWorksheetTitles,
  getFileFormat,
  getFileIcon,
  downloadPdfFileNames,
  GLOBAL_DATETIME_FORMAT,
  getUserName,
  calcFileSize,
  sleep
} from '../../shared/utility';
import graphQLClientInstance from '../../axios-graphql-client';

import Table, { tableOrigin } from '../UI/Table/Table';
import IndeterminateCheckbox from '../UI/IndeterminateCheckbox/IndeterminateCheckbox';

import logo from '../../logo.svg';

import * as actions from '../../store/actions';
import { VarietyDataSheetPDF } from '../../components/PDF/VarietyDataSheetPDF/VarietyDataSheetPDF';
import { useParams, Link } from 'react-router-dom';
import { generatexlx } from '../../exportXls';
import { pdf } from '@react-pdf/renderer';
import { TestDataSheetPDF } from '../../components/PDF/TestDataSheetPDF/TestDataSheetPDF';
import AdviceStatusBadge from '../../components/UI/AdviceStatusBadge/AdviceStatusBadge';
import { useAlert } from '../../shared/AlertService';
import { FONTAWESOME_ICON_NAMES } from '../../fontawesome';
import Loader from '../UI/Loader/Loader';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const TestDataSheet = (props: any) => {
  const { t } = useTranslation();
  const params = useParams();

  const {
    currentIndex,
    totalIndex,
    count,
    testDataSheetPrevious,
    testDataSheetNext,
  } = props;

  const [testId, setTestId] = useState(props.test_id);

  const testIdRef = React.useRef<number|null>();
  testIdRef.current = testId;

  const [data, setData] = useState<ITestDataSheet|null>(null);
  const dataRef = React.useRef<ITestDataSheet|null>(null);
  dataRef.current = data;

  const [adviceComments, setAdviceComments] = useState<ICommentResponse[]|[]>([]);
  const [testResults, setTestResults] = useState<ITestResultsResponse[]|[]>([]);
  const [resultsListPaginated, setResultsListPaginated] = useState<ITestResultsResponse[]|[]>([]);

  const [openRegionSummary, setOpenRegionSummary] = useState(true);
  const [openRegionAdvice, setOpenRegionAdvice] = useState(true);
  const [openRegionTestResults, setOpenRegionTestResults] = useState(true);
  const [openRegionMessages, setOpenRegionMessages] = useState(true);
  const [openNewMessage, setOpenNewMessage] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [isLoading, setIsLoading] = React.useState(false);
  const [testResultsLoading, setTestResultsLoading] = React.useState(true);

  const [loaderModalIsLoading, setLoaderModalIsLoading] = React.useState(false);

  const isAdvancedUser = isAdvanced();

  const testResultsRef = React.useRef<ITestResultsResponse[]|[]>();
  testResultsRef.current = testResults;

  const testResultsPaginatedRef = React.useRef<ITestResultsResponse[]|[]>([]);
  testResultsPaginatedRef.current = resultsListPaginated;

  const activeTabRef = React.useRef(0);
  activeTabRef.current = activeTab;

  const [resultsPageSize, setResultsPageSize] = useState(20);

  const [newComment, setNewComment] = useState("");

  const [hideMarkUnread, setHideMarkUnread] = useState(false);
  const alert = useAlert();

  const setTestData = (id: number) => {
    setTestId(id);
    graphQLClientInstance.post(API_URLS.VIEW_TESTS, {test_ids: [id]})
    .then(res => {
      if (res.data?.tests_list?.length) {
        setData({
          ...res.data.tests_list[0],
          species_id: res.data.tests_list[0]['specieid'],
          class_code: res.data.tests_list[0]['class_code'],
          test_id: res.data.tests_list[0]['testid'],
          breeder_name: res.data.tests_list[0]['breedername'],
          breeder_ref: res.data.tests_list[0]['breederreference'],
          species_latin_name: res.data.tests_list[0]['species_name'],
        });
      }
    })
    .catch(err => {
      console.log(err);
    })
  }

  React.useEffect(() => {
    if (props.test_id) {
      setTestId(props.test_id);
      setData({
        test_id: props.test_id,
        advice_request_date: props.advice_request_date,
        advice_requested_by: props.advice_requested_by,
        advice_cancel_date: props.advice_cancel_date,
        advice_cancelled_by: props.advice_cancelled_by,
        request_advice_id: props.request_advice_id,
        analysis_date: props.analysis_date,
        analysisby: props.analysisby,
        contact_name: props.contact_name,
        standard_advice: props.standard_advice,
        original_advice: props.original_advice,
        cpvo_advice: props.cpvo_advice,
        batch_name: props.batch_name,
        breeder_name: props.breeder_name,
        breeder_ref: props.breeder_ref,
        denomination: props.denomination,
        species_id: props.species_id,
        class_code: props.class_code,
        species_latin_name: props.species_latin_name,
        test_date: props.test_date,
        test_response: props.test_response,
        user_remark: props.user_remark,
        test_results: { denominations: [], eutm: [] }
      });
    } else if (props.notification_test_id) {
      setTestData(props.notification_test_id);
    }
  }, [props]);

  React.useEffect(() => {
    if (Object.keys(params).length) {
      setTestData((params as ITestDataSheetParams).testid);
    }
  }, [params]);

  React.useEffect(() => {
    if (testId) {
      setAdviceComments([]);
      graphQLClientInstance.get(`api/v1/tests/${testId}/comments`)
        .then(res => {
          if (res.data && Array.isArray(res.data) && res.data.length) {
            setAdviceComments((res.data as ICommentResponse[]).sort(compareCommentDate));
          }
        })
        .catch(err => {
          console.log(err);
        });
      setTestResultsLoading(true);
      setTestResults([]);
      graphQLClientInstance.get(`api/v1/tests/${testId}`)
        .then(res => {
          if (res.data.testresults_list) {
            setTestResults(res.data.testresults_list.map((testResult: any) => {
              return {
                ...testResult,
                denomination_species: [testResult.denomination, testResult.speciename]
              }
            }));
            setTestResultsLoading(false);
          }
        })
        .catch(err => {
          console.log(err);
          setTestResultsLoading(false);
        });
      }
  }, [testId]);

  React.useEffect(() => {
    if (testId && props.notifications?.filter((notification: any) => notification.testid === testId).length) {
      graphQLClientInstance.patch(API_URLS.NOTIFICATIONS_READ_UNREAD, {
        test_ids: [testId],
        read_unread: 1
      }).then((res: any) => {
        if (res.data?.response === "OK") {
          props.onMarkAsReadNotification(testId);
        }
      }).catch((err: any) => console.log(err));
    }
  }, [testId, props.notifications]);

  const downloadExcelCB = React.useCallback( async ({ values }) => {
    let myData: any[] = [];
    let currentTab: any = 0;
    let headers: any[] = [];

    myData = testResultsPaginatedRef.current;
    currentTab = activeTabRef.current;

    if(currentTab === 0) {
     headers = [
        testResultsListReturnTypes.SCORE,
        testResultsListReturnTypes.DENOMINATION,
        testResultsListReturnTypes.SPECIES_LATIN_NAME,
        testResultsListReturnTypes.BREEDERS_REFERENCE,
        testResultsListReturnTypes.VARIETY_STATUS,
        testResultsListReturnTypes.VARIETY_STATUS_DATE,
        testResultsListReturnTypes.DENOMINATION_STATUS,
        testResultsListReturnTypes.REGISTER,
        testResultsListReturnTypes.BREEDERS_NAME,
        testResultsListReturnTypes.TITLE_HOLDER,
        testResultsListReturnTypes.APPLICANT,
        testResultsListReturnTypes.MAINTAINER,
      ]
    } else if (currentTab === 1) {
      headers = [
        testResultsListReturnTypes.SCORE,
        testResultsListReturnTypes.DENOMINATION,
        testResultsListReturnTypes.APPLICATION_NUMBER,
        testResultsListReturnTypes.VARIETY_STATUS_DATE,
        testResultsListReturnTypes.APPLICANT,
        testResultsListReturnTypes.VARIETY_STATUS
      ]
    }

    const flattenData: any[] = myData.flat(2);
    let file = "";
    file = await generatexlx(
      flattenData,
      headers,
      downloadExcelWorksheetTitles.TEST_DATA_SHEET_WORKSHEET
    ).catch((err) => {
      console.log(err);
    });

    if (file) {
      const blob = new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      downloadBlob(blob, downloadExcelFileNames.TEST_DATA_SHEET);
    }

  }, []);

  const initialSelectedColumns = [
    {
      name: testResultsListReturnTypes.DENOMINATION_SPECIES,
      label: <Translation>{(translate) =>  <>
                                            {translate('denomination')}
                                            <br />
                                            {translate('species')}
                                          </>
                            }</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 0
    },
    {
      name: testResultsListReturnTypes.BREEDERS_REFERENCE,
      label: <Translation>{(translate) =>  translate('breeders_reference')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 2,
    },
    {
      name: testResultsListReturnTypes.VARIETY_STATUS,
      label: <Translation>{(translate) =>  translate('variety_status')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 3,
    },
    {
      name: testResultsListReturnTypes.VARIETY_STATUS_DATE,
      label: <Translation>{(translate) =>  translate('date')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 4,
    },
    {
      name: testResultsListReturnTypes.DENOMINATION_STATUS,
      label: <Translation>{(translate) =>  translate('denomination_status')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 5,
    },
    {
      name: testResultsListReturnTypes.REGISTER,
      label: <Translation>{(translate) =>  translate('register')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 6,
    },
    {
      name: testResultsListReturnTypes.BREEDERS_NAME,
      label: <Translation>{(translate) =>  translate('breeder')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 7,
    },
    {
      name: testResultsListReturnTypes.TITLE_HOLDER,
      label: <Translation>{(translate) =>  translate('holder')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 8,
    },
    {
      name: testResultsListReturnTypes.APPLICANT,
      label: <Translation>{(translate) =>  translate('applicant')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 9,
    },
    {
      name: testResultsListReturnTypes.MAINTAINER,
      label: <Translation>{(translate) =>  translate('maintainer')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 10,
    },
    {
      name: testResultsListReturnTypes.SCORE,
      label: <Translation>{(translate) =>  translate('score')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 11
    }
  ];


  const eutmSelectedColumns = [
    {
      name: testResultsListReturnTypes.DENOMINATION,
      label: <Translation>{(translate) =>  translate('denomination')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 0
    },
    {
      name: testResultsListReturnTypes.APPLICATION_NUMBER,
      label: <Translation>{(translate) =>  translate('application_number')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 1,
    },
    {
      name: testResultsListReturnTypes.VARIETY_STATUS_DATE,
      label: <Translation>{(translate) =>  translate('application_date')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 2,
    },
    {
      name: testResultsListReturnTypes.APPLICANT,
      label: <Translation>{(translate) =>  translate('applicant')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 3,
    },
    {
      name: testResultsListReturnTypes.VARIETY_STATUS,
      label: <Translation>{(translate) =>  translate('status')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 4,
    },
    {
      name: testResultsListReturnTypes.SCORE,
      label: <Translation>{(translate) =>  translate('score')}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 5
    },
  ];

  const loaderModal = (
    <Loader show={loaderModalIsLoading}></Loader>
  )

  const selectedTestResultsData = React.useCallback(({ data: selectedData }) => {
    const varIds = selectedData.map((id: number) => id.toString());

    if (varIds.length) {
    setLoaderModalIsLoading(true);
      graphQLClientInstance.post(API_URLS.GRAPHQL, getDataSheetFromVidQuery(varIds))
      .then(async res => {
        if (res?.data?.data?.datasheetFromVid?.length) {
          const validVarieties = res.data.data.datasheetFromVid.map((item: { varietyid: any; }) => item.varietyid);
          const testResultsVarities = testResultsRef.current?[...testResultsRef.current]:[];
          const invalidVarieties = selectedData.filter((e: ITestResultsResponse) => !validVarieties.includes(e));
          const invalidVarietiesDenominations = testResultsVarities.filter((varieties) => invalidVarieties.includes(varieties.var_id)).map(item => item.denomination);

          // @ts-ignore
          const myPdf = pdf({});
          await sleep(100);
          // @ts-ignore
          myPdf.updateContainer(<VarietyDataSheetPDF data={[...res.data.data.datasheetFromVid]} invalidDenoms={[...invalidVarietiesDenominations]}/>);
          myPdf.toBlob().then(blob =>{
            downloadBlob(blob, downloadPdfFileNames.TEST_DATA_SHEET_SELECTED_RESULTS_PDF);
          })
        } else {
          alert({
            catchOnCancel: false,
            title: t("alert"),
            body: t("invalid_denominations", {denoms: selectedData.length})
          })
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => setLoaderModalIsLoading(false));
    }
  }, [])

  const tableColumns = React.useMemo(() => {
    const columns = activeTab?eutmSelectedColumns:initialSelectedColumns;
    return [
      {
        id: TABLE_SELECT_ROW,
        Header: ({ getToggleAllRowsSelectedProps }: { getToggleAllRowsSelectedProps: any }) => (
          <div>
            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        Cell: ({ row }: { row: any }) => (
          <div>
            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          </div>
        ),
      },
      ...columns.map((item: any) => { return {...item, Header: item.label, accessor: item.name}})
    ]
  }, [activeTab]);


  const fetchData = React.useCallback(({ pageSize: tablePageSize, sortBy: tableSortBy }) => {
    setResultsPageSize(tablePageSize);
    // @ts-ignore
    const resultsArray = testResultsRef.current?[...testResultsRef.current]:[];

    let results = resultsArray.filter((result: any) => result[testResultsListReturnTypes.EUTM] === activeTab).map((result: any) => {
      let register = null;

      if (result[testResultsListReturnTypes.EUTM] === 0 && result[testResultsListReturnTypes.REGISTER] && result[testResultsListReturnTypes.REGISTER].length > 2) {
        register = `${result[testResultsListReturnTypes.REGISTER].substring(0,2)} -  ${result[testResultsListReturnTypes.REGISTER].substring(2)}`;
      }

      return {
        ...result,
        [testResultsListReturnTypes.REGISTER]: register
      };
    });

    let sortBy = {"id": testResultsListReturnTypes.SCORE, desc: false};

    if (tableSortBy.length > 0) {
      sortBy = tableSortBy[0];
    }

    results.sort(compareResults(sortBy));

    if (tablePageSize > 0) {
      results = results.slice(0, tablePageSize);
    }

    setResultsListPaginated(results)

  }, [activeTab])

  const changeTab = React.useCallback((newTab) => {
    setActiveTab(newTab);
  }, []);

  const requestAdvice = () => {
    if (testIdRef.current) {
      setOpenRegionAdvice(true);
      setIsLoading(true);

      graphQLClientInstance.post(API_URLS.TESTS_ADVICE_REQUEST, {"test_ids":[testIdRef.current]})
        .then(res => {
          if (res.data?.response === "OK") {
            setData({...(dataRef.current as ITestDataSheet), request_advice_id: 2, advice_request_date: new Date().getTime(), advice_requested_by: getUserName()})
            props.onReqAdviceTestDenomination(testIdRef.current, getUserName(), new Date().getTime());
            props.onUpdateReqAdvice?.(testIdRef.current, 2, new Date().getTime(), getUserName());
          } else if (res.data?.response) {
            alert({
              catchOnCancel: false,
              title: t("alert"),
              body: t(`error_messages.${res.data.response}`)
            })
          }
        })
        .catch(err => {
          console.log(err);
        }).finally(() => setIsLoading(false));
    }
  }

  const requestAdviceCancel = () => {
    if (testIdRef.current) {
      setIsLoading(true);
      graphQLClientInstance.post(API_URLS.TESTS_ADVICE_CANCEL, {"test_ids":[testIdRef.current]})
        .then(res => {
          if (res.data?.response === "OK") {
            setData({...(dataRef.current as ITestDataSheet),
              request_advice_id: 1,
              advice_cancel_date: new Date().getTime(),
              advice_cancelled_by: getUserName(),
              advice_request_date: null,
              advice_requested_by: null
            })
            props.onReqAdviceCancelTestDenomination(testIdRef.current, getUserName(), new Date().getTime())
            props.onUpdateReqAdvice?.(testIdRef.current, 1, null, null);
          }
        })
        .catch(err => {
          console.log(err);
        }).finally(() => setIsLoading(false));
    }
  }

  const inputReference = React.createRef<HTMLInputElement>();

  const [selectedFiles, setSelectedFiles] = useState<any[]>([]);
  const [validFiles, setValidFiles] = useState<any[]>([]);
  const validFilesRef = React.useRef<any[]>([]);
  validFilesRef.current = validFiles;
  const [unsupportedFiles, setUnsupportedFiles] = useState<any[]>([]);

  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const uploadedFilesRef = React.useRef<any[]>();
  uploadedFilesRef.current = uploadedFiles;

  React.useEffect(() => {
    const filteredArr = selectedFiles.reduce((acc: any, current: any) => {
        const x = acc.find((item: any) => item.name === current.name);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
    }, []);
    setValidFiles([...filteredArr]);
    if (inputReference.current) {
      inputReference.current.value = "";
    }
  }, [selectedFiles]);

  const handleFiles = (files: any) => {
    for (const file of files) {
        const errorMessage = checkFileError(file);
        if (errorMessage === "") {
            setSelectedFiles(prevArray => [...prevArray, file]);
        } else {
            file['invalid'] = true;
            file['errorMessage'] = errorMessage;
            setSelectedFiles(prevArray => [...prevArray, file]);
            setUnsupportedFiles(prevArray => [...prevArray, file]);
        }
    }
  }

  const checkFileError = (file: any) => {
    if (file.size > 6 * 1024 * 1024) {
      return "error_messages.max_file_size_exceeded";
    }

    return "";
  }

  const removeFile = (name: any) => {
    const index = validFiles.findIndex((e: any) => e.name === name);
    const index2 = selectedFiles.findIndex((e: any) => e.name === name);
    const index3 = unsupportedFiles.findIndex((e: any) => e.name === name);
    validFiles.splice(index, 1);
    selectedFiles.splice(index2, 1);
    setValidFiles([...validFiles]);
    setSelectedFiles([...selectedFiles]);
    if (index3 !== -1) {
        unsupportedFiles.splice(index3, 1);
        setUnsupportedFiles([...unsupportedFiles]);
    }
  }

  const [uploadModalShow, setUploadModalShow] = useState(false);

  const handleUploadModalClose = () => {
    setSelectedFiles([]);
    setUnsupportedFiles([]);
    setUploadedFiles([]);
    if (inputReference.current) {
      inputReference.current.value = "";
    }
    setNewComment("");
    setUploadModalShow(false);
  }

  const handleUploadModalShow = () => setUploadModalShow(true);

  const [uploadModalProgress, setUploadModalProgress] = useState(<></>);
  const [uploadModalBody, setUploadModalBody] = useState<{text: string, status:number, error_message?: string}[]|[]>([]);
  const uploadModalBodyRef = React.useRef<{text: string, status:number, error_message?: string}[]|[]>([]);
  uploadModalBodyRef.current = uploadModalBody;

  const printStatus = (status: number, error = "") => {
    switch (status) {
      case -1:
        return <span style={{color: "#E53138"}}>{t("failed")} {printError(error)}</span>;
      case 1:
        return <span style={{color: "#009435"}}>{t("done")}</span>;
      case 0:
        return <Spinner animation="border" size="sm" variant="primary" />
      default:
        return "";
    }
  }

  const printError = (error: string) => {
    return error?`(${t(`error_messages.${error}`)})`:"";
  }

  const uploadModal = (
    <Modal
      centered
      keyboard={false}
      backdrop="static"
      show={uploadModalShow}
      onHide={handleUploadModalClose}
      >
      <Modal.Header>
        <Modal.Title>
          {t('creating_comment')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span style={{wordBreak: "break-all"}}>
          {uploadModalProgress}
          {/* @ts-ignore */}
          {uploadModalBody.map((item: any, index: number) =>
            <React.Fragment key={`upload-status-${index}`}>
              {item.text}... {printStatus(item.status, item.error_message)}<br />
            </React.Fragment>)}
        </span>
      </Modal.Body>
      <Modal.Footer>

          <Button variant="outline-primary" disabled={isLoading} onClick={handleUploadModalClose}>
            {t("close")}
          </Button>
        </Modal.Footer>
    </Modal>
  )

  function readFileAsync(file: any, commentId: number) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = (e: any) => {
        const sender = Buffer.from(e.target.result,'base64')
        graphQLClientInstance.post(`api/v1/tests/comments/${commentId}/attachments`,
          new Uint32Array(sender.buffer,sender.byteOffset,sender.byteLength / Uint32Array.BYTES_PER_ELEMENT),
          {
            headers: {
              'Filename': file.name,
              'Content-Type': file.name.endsWith(".msg") ? "application/vnd.ms-outlook" : file.type
            },
            onUploadProgress: (progressEvent: any) => {
              const uploadPercentage = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
              setUploadModalProgress(
                  <ProgressBar  className="w-100" now={uploadPercentage} label={`${uploadPercentage}%`} />
                )
          }
        })
        .then(res => {
          resolve(res.headers.location);
        })
        .catch(err => {
          reject(err);
        })
      };

      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    })
  }

  const updateModalLastStatus = (status: number, error = "") => {
    if (uploadModalBodyRef.current?.length) {
      const items = [...uploadModalBodyRef.current];
      items[items.length-1]['status'] = status;
      if (error) {
        items[items.length-1]['error_message'] = error;
      }
      setUploadModalBody(items)
    }
  }

  const uploadAttachments = async (commentId: number) => {
    for (const validFile of validFilesRef.current) {
      setUploadModalBody(prevUploadModalBody => [
                                                  ...prevUploadModalBody,
                                                  {
                                                    text: t("uploading_file", { file: validFile.name }),
                                                    status: 0
                                                  }
                                                ]
                          );
      await readFileAsync(validFile, commentId)
      .then((attachmentId: any) => {
        setUploadedFiles(prevUploadedFiles => [
                                                ...prevUploadedFiles,
                                                {
                                                  commentId: commentId,
                                                  href: `api/v1/tests/comments/${commentId}/attachments/${attachmentId}`,
                                                  file_name: validFile.name,
                                                  file_type: validFile.type,
                                                  id: attachmentId
                                                }
                                              ])
        updateModalLastStatus(1)
      })
      .catch((err: any) => {
        const errorMessage = err?.response?.data?.message;
        updateModalLastStatus(-1, errorMessage)
      }).finally(() => setUploadModalProgress(<></>))
    }
  }

  const sendComment = async () => {
    if (newComment) {
      handleUploadModalShow();
      setIsLoading(true);
      setUploadModalBody([{text: `${t("creating_comment")}...`, status: 0}]);
      graphQLClientInstance.post(`api/v1/tests/${testIdRef.current}/comments`, { "comment": newComment })
        .then(async res => {
          if (!res.data.message) {
            updateModalLastStatus(1)
            if (validFilesRef.current) {
              const commentId = res.headers.location;
              await uploadAttachments(commentId);
            }
            await graphQLClientInstance.get(`api/v1/tests/${testId}/comments`)
                  .then(commentsRes => {
                    if (commentsRes.data && Array.isArray(commentsRes.data) && commentsRes.data.length) {
                      setAdviceComments(commentsRes.data as ICommentResponse[]);
                    }
                  })
                  .catch(commentsErr => {
                    console.log(commentsErr);
                  });
          }
        })
        .catch(err => {
          console.log(err);
          updateModalLastStatus(-1);
        }).finally(() => setIsLoading(false));
    }
  }

  const downloadAttachment = (attachment: ICommentResponseAttachment) => {
    graphQLClientInstance.get(attachment.href, {
      responseType:'arraybuffer'}).then((res: any) => {
      const blob = new Blob([res.data], { type: attachment.file_type});
      downloadBlob(blob, attachment.file_name);
    }).catch((err: any) => console.log(err));
  }

  let testResultsDenominationsData = [...testResults?.filter((result: any) => result[testResultsListReturnTypes.EUTM] === 0)];
  let testResultsEutmData = [...testResults?.filter((result: any) => result[testResultsListReturnTypes.EUTM] === 1)];

  if (resultsPageSize > 0) {
    testResultsDenominationsData = testResultsDenominationsData.slice(0, resultsPageSize);
    testResultsEutmData = testResultsEutmData.slice(0, resultsPageSize);
  }

  return (
    <div className={classes.testDataSheet}>{data?(
      <>
        {!props.standAlone?
        <Container>
          <Row>
            <Col md="8" className={classes.dataSheetActions}>
              <Button
                disabled={testResultsLoading}
                onClick={() => {
                  setLoaderModalIsLoading(true);
                  // @ts-ignore
                  const myPdf = pdf({});
                  // @ts-ignore
                  myPdf.updateContainer(<TestDataSheetPDF
                    data={[{
                      ...({
                          ...data,
                          test_results: {
                            denominations: testResultsDenominationsData,
                            eutm: testResultsEutmData
                          }
                        } as ITestDataSheet)}]} />);
                  myPdf.toBlob().then(blob => {
                    downloadBlob(blob, downloadPdfFileNames.TEST_DATA_SHEET_RESULTS_PDF);
                  })
                  .finally(() => setLoaderModalIsLoading(false));
                }}
                variant="light"><FontAwesomeIcon icon={['fas', 'arrow-alt-circle-down']}  /> {t("download_pdf")}</Button>
              {data.request_advice_id === CPVO_EXPERT_ADVICE_STATUS.OBSERVATION && !hideMarkUnread?
                <Button onClick={() => {
                    graphQLClientInstance.patch(API_URLS.NOTIFICATIONS_READ_UNREAD, {
                      test_ids: [testId],
                      read_unread: 0
                    }).then((res: any) => {
                      if (res.data.response && res.data.response === "OK") {
                        setHideMarkUnread(true);
                      }
                    }).catch((err: any) => console.log(err));
                  }}
                  variant="light"><FontAwesomeIcon icon={['fas', 'eye-slash']}  /> {t("mark_unread")}</Button>
                :<></>}
            </Col>
            <Col md="4" className={[classes.dataSheetNavigation, "text-right"].join(" ")}>
              {props.hideNavigation?<></>:
                <>
                  <span className={classes.currentCount}>{t("range", {start: totalIndex, end: count})}</span>
                  <Button
                    onClick={() => testDataSheetPrevious({currentIndex: currentIndex})}
                    disabled={totalIndex === 1}
                    variant="link">
                      <FontAwesomeIcon icon={['fas', 'chevron-left']} className={classes.dataSheetChevron} />
                  </Button>
                  <Button
                    onClick={() => testDataSheetNext({currentIndex: currentIndex})}
                    disabled={totalIndex === count}
                    variant="link">
                      <FontAwesomeIcon icon={['fas', 'chevron-right']} className={classes.dataSheetChevron} />
                  </Button>
                </>}
            </Col>
          </Row>
        </Container>
        :<></>}
        <Container className={[classes.collapsibleContent, (props.standAlone ? "mt-3": "")].join(" ")}>
            <Row className={classes.header}>
                <Col md="3" lg="2">
                <span>
                    {t("denomination_test")}
                </span>
                </Col>
                <Col md="9" lg="10" className={classes.headerSummary}><span>#{testIdRef.current} - {convertDate(data.test_date)} - {data.contact_name}</span>
                  {props.standAlone?(
                    <Link style={{marginLeft: "12px"}} to={`/`}>
                      <img
                        src={logo}
                        width="25"
                        height="24"
                        alt="CPVO Varity Finder"
                      />
                    </Link>
                  ):<></>}
                </Col>
            </Row>
            <Row className={classes.body}>
              <Container className={classes.region}>
                <Row className={classes.regionHeader}>
                  <Col md="3" lg="2" className={classes.title}>{t("summary")}</Col>
                  <Col md="9" lg="10" className={classes.summary}>
                    <span className="float-right">
                      <Button
                        onClick={() => setOpenRegionSummary(!openRegionSummary)}
                        className={openRegionSummary?"open":""}
                        style={{
                          'padding': '0 5px',
                          'background': '#E8E8E8',
                          'borderBottomLeftRadius': '0px',
                          'borderBottomRightRadius': '0px'
                        }}
                        variant="link"><FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} /></Button>
                    </span>
                  </Col>
                </Row>
                <Collapse in={openRegionSummary}>
                  <Row>
                    <Col md="3" lg="2" className={classes.dataSheetResultKeys}>{t("denomination_tested")}</Col>
                    <Col md="9" lg="10" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>{data.denomination}</Col>

                    <Col md="3" lg="2" className={classes.dataSheetResultKeys}>{t("species")}</Col>
                    <Col md="9" lg="10" className={[classes.dataSheetResultValues, "font-weight-bold"].join(" ")}>{data.species_latin_name}</Col>

                    <Col md="3" lg="2" className={classes.dataSheetResultKeys}>{t("class")}</Col>
                    <Col md="9" lg="10" className={classes.dataSheetResultValues}>{data.class_code?.join("/")}</Col>

                    <Col md="3" lg="2" className={classes.dataSheetResultKeys}>{t("breeders_reference")}</Col>
                    <Col md="3" lg="4" className={classes.dataSheetResultValues}>{data.breeder_ref}</Col>

                    <Col md="3" lg="2" className={classes.dataSheetResultKeys}>{t("breeders_name")}</Col>
                    <Col md="3" lg="4" className={classes.dataSheetResultValues}>{data.breeder_name}</Col>

                    <Col md="3" lg="2" className={classes.dataSheetResultKeys}>{t("remark")}</Col>
                    <Col md="9" lg="10" className={classes.dataSheetResultValues} dangerouslySetInnerHTML={{__html: data.user_remark?.replace(/\n/g,"<br>")}}></Col>

                  </Row>
                </Collapse>
              </Container>

              {isAdvancedUser?
              <Container className={classes.region}>
                <Row className={classes.regionHeader}>
                  <Col md="5" lg="6" className={[classes.title, data.advice_request_date || data.advice_cancel_date ? "border-0" : "", "text-nowrap"].join(" ")}>
                    {t("cpvo_expert_advice")}
                    {data.analysis_date ?
                      <span className="font-weight-normal">
                        {` ${t("date_on")} ${convertDate(data.analysis_date, GLOBAL_DATETIME_FORMAT)}`}
                        {data.analysisby && data.analysisby !== " " ?
                          ` - ${data.analysisby}`
                        : ""}
                      </span>
                    : <></>}
                  </Col>
                  <Col md="7" lg="6" className={[classes.summary, "text-right", data.advice_request_date || data.advice_cancel_date ? "border-0" : ""].join(" ")}>
                    <span
                      style={!(data.request_advice_id === CPVO_EXPERT_ADVICE_STATUS.NOT_REQUESTED && checkToday(data.test_date))
                              && data.request_advice_id !== CPVO_EXPERT_ADVICE_STATUS.REQUESTED ?
                              {
                                marginRight: data.advice_request_date || data.advice_cancel_date ? '40px' : '14px'
                              } : {}}>
                      <AdviceStatusBadge id={data.request_advice_id} />
                    </span>
                    {' '}
                    {data.request_advice_id === CPVO_EXPERT_ADVICE_STATUS.NOT_REQUESTED && checkToday(data.test_date)?
                      (!isLoading?
                        <Button
                          id="requestAdvice"
                          onClick={() => requestAdvice()}
                          variant="primary"
                          size="sm"
                          style={{marginRight: data.advice_cancel_date?'40px':'14px'}}
                          className={[classes.badge, classes.reqAdviceButton].join(" ")}>
                            {t("request_advice_button")}
                        </Button>
                        :<Spinner animation="border" size="sm" variant="primary" style={{marginRight: data.advice_cancel_date?'40px':'14px'}} />)
                      :<></>}
                    {data.request_advice_id === CPVO_EXPERT_ADVICE_STATUS.REQUESTED?
                      (!isLoading?
                        <Button
                          id="requestAdvice"
                          onClick={() => requestAdviceCancel()}
                          variant="primary"
                          size="sm"
                          style={{marginRight: '40px'}}
                          className={[classes.badge, classes.reqAdviceButton, classes.cancelReqAviceButton].join(" ")}>
                            {t("request_advice_cancel_button")}
                        </Button>
                        :<Spinner animation="border" size="sm" variant="primary" style={{marginRight: '40px'}} />)
                      :<></>}
                    {!data.advice_request_date && !data.advice_cancel_date ?
                      <Button
                        onClick={() => setOpenRegionAdvice(!openRegionAdvice)}
                        className={openRegionAdvice?"open":""}
                        style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                        variant="link">
                          <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                      </Button>
                      :<></>}
                  </Col>
                  {data.advice_request_date || data.advice_cancel_date ? (
                    <>
                      <Col md="12" className={[classes.summary, "float-left"].join(" ")}>
                        {data.advice_request_date ?
                          t("advice_requested_by", {by: data.advice_requested_by, date: convertDate(data.advice_request_date, GLOBAL_DATETIME_FORMAT)})
                          : t("advice_cancelled_by", {by: data.advice_cancelled_by, date: convertDate(data.advice_cancel_date, GLOBAL_DATETIME_FORMAT)})}
                        <span className="float-right">
                          <Button
                            onClick={() => setOpenRegionAdvice(!openRegionAdvice)}
                            className={openRegionAdvice?"open":""}
                            style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                            variant="link">
                              <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                          </Button>
                        </span>
                      </Col>
                    </>)
                    : <></>
                  }
                </Row>
                <Collapse in={openRegionAdvice}>
                  <span>
                  {data.request_advice_id > 1 ? (
                    <>
                      {data.cpvo_advice? (
                        <Row className={classes.adviceBox} dangerouslySetInnerHTML={{__html:data.cpvo_advice?.join("<br />").replace("\n","<br />")}} />
                      ) : <></>}
                      {data.standard_advice? (
                        <Row className={classes.adviceBox} dangerouslySetInnerHTML={{__html:data.standard_advice?.replace("\n","<br />")}} />
                      ) : <></>}
                        <>
                          <Row className={classes.regionHeader}>
                            <Col md="3" lg="2" className={classes.title}>{t("messages")}</Col>
                            <Col md="9" lg="10" className={[classes.summary, "text-right"].join(" ")}>
                              {data.request_advice_id !== CPVO_EXPERT_ADVICE_STATUS.CANCELLED &&
                              <Button
                                  onClick={() => {
                                    setOpenNewMessage(!openNewMessage);
                                    setOpenRegionMessages(true);
                                  }}
                                  style={{'padding': '0 5px'}}
                                  variant="link">
                                  <FontAwesomeIcon
                                      icon={['fas', openNewMessage ? 'envelope-open-text' : 'envelope']}
                                      className={classes.paginationChevron}/>
                              </Button>
                              }
                              <Button
                                onClick={() => setOpenRegionMessages(!openRegionMessages)}
                                className={openRegionMessages?"open":""}
                                style={{'padding': '0 5px', marginLeft: '10px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                                variant="link">
                                  <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                              </Button>
                            </Col>
                          </Row>
                          <Collapse in={openRegionMessages}>
                            <span>
                              {openNewMessage ? (
                                <>
                                 <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="newComment"
                                    style={{resize: 'none', marginTop: '10px'}}
                                    value={newComment}
                                    onChange={(evt: React.SyntheticEvent) => setNewComment((evt.target as HTMLInputElement).value)}
                                  />
                                  <Row>
                                    <Col md={6} className={"text-left"} style={{paddingLeft:'0', paddingRight:'0'}}>
                                      <input multiple type="file" ref={inputReference} hidden onChange={(e: any) => {
                                        // (e.target.value)
                                        handleFiles(e.target.files);
                                      }}  />
                                      <Button style={{paddingLeft:'0', paddingRight:'0'}} variant="link" className="ui button" onClick={() => {
                                        if (inputReference.current) {
                                          inputReference.current.click();
                                        }
                                      }}>
                                          {t("add_attachments")}
                                      </Button>
                                    </Col>
                                    <Col md={6} className={"text-right"} style={{paddingLeft:'0', paddingRight:'0'}}>
                                      <Button
                                        disabled={newComment?.length === 0 || validFiles?.filter((file: any) => file.invalid)?.length > 0}
                                        onClick={() => sendComment()} variant="primary">{t("send")}</Button>
                                    </Col>
                                  </Row>
                                  <>
                                    {
                                      validFiles.map((validFile: any, index: number) =>
                                        <Row key={`valid-file-${index}`}>
                                          <Row className="col-md-11" style={{paddingTop: '0px', paddingLeft: '0px'}} key={`valid-file-${index}-info`}>
                                            <Col md={6} className={[classes.fileName, validFile.invalid ? classes.fileError : ''].join(" ")}>
                                              {validFile.name}
                                            </Col>
                                            <Col md={2} className={classes.fileSize}>
                                              ({calcFileSize(validFile.size)})
                                            </Col>
                                            <Col md={4} className={validFile.invalid ? classes.fileErrorMessage : ""}>
                                              {t(validFile.errorMessage)}
                                            </Col>
                                          </Row>
                                          <Col md={1} className={classes.fileRemove} onClick={() => removeFile(validFile.name)}>
                                            <FontAwesomeIcon icon={['fas', 'times-circle']}/>
                                          </Col>
                                        </Row>
                                      )
                                    }
                                  </>
                                </>
                              ) : <></>}
                              {(adviceComments as ICommentResponse[]).map((comment: ICommentResponse, comIndex: number) => (
                                <React.Fragment key={`advice-comment-${comIndex}`}>
                                  <Row className={[classes.commentTitle, comment.is_cpvo?classes.cpvoComment:""].join(" ")}>
                                    {convertDate(comment.comment_date, "DD/MM/YYYY HH:mm")} - {comment.commenter_name}{comment.is_cpvo?` (CPVO)`:""}
                                  </Row>
                                  <Row className={[classes.comment, comment.is_cpvo?classes.cpvoComment:""].join(" ")} style={{paddingLeft: '30px'}}>
                                    {comment.data}
                                  </Row>
                                  {comment.attachments?.length?
                                    <Row className={classes.attachmentsContainer}>
                                        {comment.attachments.map((attachment: ICommentResponseAttachment, attIndex: number) => {
                                          return (
                                            <div
                                              key={`comment-${comIndex}-attachment-${attIndex}`}
                                              className={["w-100", classes.attachment].join(" ")}
                                              onClick={() => downloadAttachment(attachment)}>
                                              <div className={classes.attachmentFileIconContainer}>
                                                <FontAwesomeIcon
                                                  icon={getFileIcon(getFileFormat(attachment?.file_name)) as IconProp}
                                                  className="align-middle"
                                                  style={{margin: '0px 9px 0px 0px'}}
                                                  color="#00447A"/>
                                              </div>
                                              <div className={classes.attachmentFileNameContainer}>
                                                <span className={classes.attachmentFileName}>
                                                  {attachment.file_name}
                                                </span>
                                              </div>
                                            </div>
                                          )
                                        })
                                        }
                                    </Row>
                                  :<></>}
                                </React.Fragment>
                              ))}
                              {data.original_advice && <span className={classes.originalAdvice} dangerouslySetInnerHTML={{__html:data.original_advice?.replace(/\\n/g,"<br />")}}/>}
                              </span>
                          </Collapse>
                        </>
                      </>)
                    :<></>}
                  </span>
                </Collapse>
              </Container>
              :<></>}

              <Container className={[classes.region, classes.testResultsRegion].join(" ")}>
                <Row className={[classes.regionHeader, classes.testResultsRegionHeader].join(" ")}>
                  <Col md="3" lg="2" className={classes.title}>{t("test_results")}</Col>
                  <Col md="9" lg="10" className={classes.summary}>
                    <span className="float-right">
                      <Button
                        onClick={() => setOpenRegionTestResults(!openRegionTestResults)}
                        className={openRegionTestResults?"open":""}
                        style={{'padding': '0 5px', 'background': '#E8E8E8', 'borderBottomLeftRadius': '0px', 'borderBottomRightRadius': '0px'}}
                        variant="link">
                          <FontAwesomeIcon icon={['fas', FONTAWESOME_ICON_NAMES.CHEVRON_UP]} className={classes.paginationChevron} />
                      </Button>
                    </span>
                  </Col>
                </Row>
                <Collapse in={openRegionTestResults}>
                  <Row className={classes.testResultsRegionCollapseRow}>
                    <Col md="3" lg="2" className={[classes.testResultsDiv, classes.dataSheetResultKeys].join(" ")}>{t("test_status")}</Col>
                    <Col md="9" lg="10" className={[classes.testResultsDiv, classes.dataSheetResultValues].join(" ")}>{data.test_response}</Col>
                    <Col md="12" className={classes.testResultsDiv}>
                    {testResults && testResults.length?
                      <Table
                        columns={tableColumns}
                        selectedData={selectedTestResultsData}
                        hideColumnsButton={true}
                        isSortable={true}
                        data={resultsListPaginated}
                        downloadExcel={downloadExcelCB}
                        fetchData={fetchData}
                        pageCount={resultsListPaginated.length}
                        totalCount={resultsListPaginated.length}
                        fakeCount={testResults.length}
                        pageIndex={0}
                        showPagination={true}
                        origin={tableOrigin.TEST_DATA_SHEET}
                        changeTab={changeTab}
                        activeTab={activeTab}
                        pageSizeOptions={[50, 100, 500, -1]}
                      />:<></>}
                      {loaderModal}
                    </Col>
                  </Row>
                </Collapse>
              </Container>
            </Row>
        </Container>
        {uploadModal}
      </>
    ):<div className="text-center"><Spinner animation="border" variant="primary" /></div>}
    </div>
  )
};

const mapStateToProps = (state: any) => {
  return {
      testDenominations: state.testDenominations.tests,
      notifications: state.notifications.items
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onReqAdviceTestDenomination: (testid: number, by: string|number, date: number) =>
      dispatch(actions.reqAdviceTestDenomination({id: testid, advice_requested_by: by, advice_request_date: date})),
    onReqAdviceCancelTestDenomination: (testid: number, by: string|number, date: number) =>
      dispatch(actions.reqAdviceCancelTestDenomination({id: testid, advice_cancelled_by: by, advice_cancel_date: date})),
    onMarkAsReadNotification: (testid: number) =>
      dispatch(actions.markAsReadNotification(testid))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TestDataSheet);

export interface ITestResultsResponse {
  apl_nb: string;
  applicantname: string;
  brd_name: string;
  brd_ref: string;
  deno_id: number;
  deno_status: string;
  denomination: string;
  eutm_tab: number;
  maintainer: string;
  register: string;
  country?: string;
  register_type?: string;
  score: number;
  speciename: string;
  testid: number;
  title_holder: string;
  totals: number;
  var_id: number;
  var_status: string;
  var_status_date: string;
  deno_valid: number;
  wt: string;
}

export interface IInvalidVarieties {
  denomination: string
}

export interface ITestDataSheet {
  advice_cancel_date: number|null;
  advice_cancelled_by: string|null;
  advice_request_date: number|null;
  advice_requested_by: string|null;
  analysis_date: number|null;
  analysisby: string;
  request_advice_id: number;
  contact_name: string;
  standard_advice: string;
  original_advice?: string;
  cpvo_advice: string[],
  batch_name: string;
  denomination: string;
  species_id: string;
  class_code: string[];
  test_date: Date;
  breeder_ref: string;
  breeder_name: string;
  user_remark: string;
  species_latin_name?: string;
  test_id: number;
  test_response: string;
  test_results: {
    denominations: ITestResultsResponse[]|[];
    eutm?: ITestResultsResponse[]|[]
  };
}

interface ITestDataSheetParams {
  testid: number;
}

interface ICommentResponseAttachment {
  commentId: number;
  file_name: string;
  file_type: string;
  href: string;
  id: number;
}

interface ICommentResponse {
  id: number;
  comment_date: string;
  comment_by: number;
  commenter_name: string;
  is_cpvo: number;
  attachments: ICommentResponseAttachment[];
  data: string;
}

const compareCommentDate = (a: any, b: any) => {
  let comparison = 0;
  if (a.comment_date > b.comment_date) {
    comparison = -1;
  } else if (a.comment_date < b.comment_date) {
    comparison = 1;
  }
  return comparison;
}
